import { useState, useEffect } from 'react';
import { BP_TABLET_MIN, BP_MOBILE_MIN, BP_NETBOOK_MAX } from '../assets/styles/breakpoints';

const useWindowSize = () => {
  const getSize = () => {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      isTablet: window.innerWidth < BP_TABLET_MIN,
      isMobile: window.innerWidth < BP_MOBILE_MIN,
      isNetbook: window.innerWidth < BP_NETBOOK_MAX,
    };
  };

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getSize());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
};

export default useWindowSize;
